<template>
  <div class="reviews-settings-cell-renderer-contact">
    <div>
      <div class="contact-attribute font-bold">
        {{ contactName }}
      </div>
      <div class="contact-attribute">
        {{ contactEmail }}
      </div>
      <div class="contact-attribute">
        {{ contactPhone }}
      </div>
    </div>

    <review-settings-cell-renderer-rating
      v-if="gpMqIsLessOrEqualLaptopMedium"
      :isAgGridComponent="false"
      :rating="rating"
      :showRatingNumber="false"
      :centered="ratingCentered"
      :size="16"
    />
  </div>
</template>

<script>
import ReviewSettingsCellRendererRating from '@/views/modules/reviews/ReviewsSettingsCellRendererRating.vue';

export default {
  name: 'ReviewsSettingsCellRendererContact',
  components: {
    ReviewSettingsCellRendererRating,
  },
  props: {
    reviewPayload: {
      type: [Object, null],
      default: () => null,
    },
    ratingCentered: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reviewData() {
      if (this.reviewPayload) {
        return this.reviewPayload;
      }

      return this.params && this.params.data
        ? this.params.data
        : null;
    },
    rating() {
      return this.reviewData ? this.reviewData.score : 0;
    },
    contactData() {
      return this.reviewData && this.reviewData.contact
        ? this.reviewData.contact
        : null;
    },
    contactName() {
      if (this.contactData && this.contactData.name) {
        return this.contactData.name;
      }

      return this.reviewData && this.reviewData.name
        ? this.reviewData.name
        : '';
    },
    contactEmail() {
      if (this.contactData && this.contactData.email) {
        return this.contactData.email;
      }

      return this.reviewData && this.reviewData.email
        ? this.reviewData.email
        : '';
    },
    contactPhone() {
      if (this.contactData && this.contactData.phoneInternational) {
        return this.contactData.phoneInternational;
      }

      return this.reviewData && this.reviewData.phone
        ? this.reviewData.phone
        : '';
    },
  },
};
</script>

<style scoped lang="scss">
.reviews-settings-cell-renderer-contact {
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  .contact-attribute {
    line-height: 1.4;
  }
}

</style>
